

import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import { form5DataInfoType } from '@/types/Information/Form5';
import { partiesDataJsonDataType } from '@/types/Information/json';
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form5";
const form5State = namespace("Form5");

@Component
export default class Form5StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form5State.State
    public form5Info: form5DataInfoType;
    
    @form5State.State
    public currentNoticeOfHearingOfAppealId: string;

     @form5State.Action
    public UpdateForm5Info!: (newForm5Info: form5DataInfoType) => void 

    @form5State.Action
    public UpdateCurrentNoticeOfHearingOfAppealId!: (newCurrentNoticeOfHearingOfAppealId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];   
 
    representationOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    courtHouseNames = [
        {text: 'Vancouver Registry', value: 'Vancouver Registry, BC Court of Appeal, The Law Courts, 400-800 Hornby Street, Vancouver, BC, V6Z 2C5'},
        {text: 'Victoria Registry', value: 'Victoria Registry, 2nd Flr, 850 Burdett Ave., Victoria, BC, V8W 9J2'}
    ];

    state = {
        firstAppellant:null,
        firstRespondent:null,
        courtHouse:null,
        timeOfAppealHearing: null,
        dateOfAppealHearing: null,
        numberOfDaysApp: null,
        numberOfDaysRes: null,
        acknowledge: null,
        authorizedName:null,
        selfRepresented: null
    }

    respondentName = ""; 
    updated=0;

    mounted() {
        this.dataReady = false;
        if(this.currentNoticeOfHearingOfAppealId){

            this.getForm5Data();  

        } else {  

            const form5Data = {} as form5DataInfoType;

            form5Data.appellants = this.partiesJson.appellants;
            form5Data.respondents = this.partiesJson.respondents;
            form5Data.formSevenNumber = this.fileNumber;
            
            form5Data.version = this.$store.state.Application.version;
            form5Data.selfRepresented = this.$store.state.Common.userSelfRepresented;
            form5Data.timeOfAppealHearing = '10:00';
            form5Data.acknowledge = false; 
            this.UpdateForm5Info(form5Data); 
            this.saveForm(true);
        }      
    }

    public extractInfo(){    

        this.applicantNames = [];
        this.respondentNames = [];

        for (const respondent of this.form5Info.respondents){
            this.respondentNames.push(respondent.name);  
        }

        for (const applicant of this.form5Info.appellants){
            this.applicantNames.push(applicant.name);  
        }
        this.dataReady = true;       

    }

    public getForm5Data() {        
       
        this.$http.get('/form5/forms/'+this.currentNoticeOfHearingOfAppealId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form5Data = response.data.data 
                const today = moment().format("YYYY-MM-DD")
                if(form5Data.dateOfAppealHearing<today){
                    form5Data.dateOfAppealHearing=null;
                }
                this.UpdateForm5Info(form5Data) 
                this.extractInfo();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            firstAppellant:null,
            firstRespondent:null,
            courtHouse:null,
            timeOfAppealHearing: null,
            dateOfAppealHearing: null,
            numberOfDaysApp: null,
            numberOfDaysRes: null,
            acknowledge: null,
            authorizedName:null,
            selfRepresented: null
        }
        this.dataReady = true; 
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');           
        return (date >= day);           
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){        

        this.state.courtHouse = !this.form5Info.courtHouse? false : null;
        this.state.firstAppellant = !this.form5Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form5Info.firstRespondent? false : null;
        //console.log(this.form5Info.timeOfAppealHearing)
        if(this.form5Info.timeOfAppealHearing?.match("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:?[0-5]?[0-9]?$")){
            this.state.timeOfAppealHearing = null;            
        }
        else
            this.state.timeOfAppealHearing =false;
        
        this.state.dateOfAppealHearing = this.form5Info.dateOfAppealHearing && this.allowedDates(this.form5Info.dateOfAppealHearing)? null: false;
        
        const numberOfDaysApp = this.form5Info.numberOfDaysApp?.trim();
        this.state.numberOfDaysApp = this.checkDay(numberOfDaysApp)==false? false : null;

        const numberOfDaysRes = this.form5Info.numberOfDaysResp?.trim();
        this.state.numberOfDaysRes = this.checkDay(numberOfDaysRes)==false? false : null;

        this.state.acknowledge = !this.form5Info.acknowledge? false : null; 
        this.state.authorizedName = !this.form5Info.authorizedName? false : null;       
        this.state.selfRepresented = this.form5Info.selfRepresented != null? null: false;

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }

    public checkDay(day: string){

        let valid = false;
        if (day && (Number(day) % 1 == 0 || Number(day) % 1 == 0.5)){
            valid = true;
        }       

        return valid;
    }

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form5/forms';

        if (this.currentNoticeOfHearingOfAppealId){
            method = 'put';
            url = '/form5/forms/'+this.currentNoticeOfHearingOfAppealId;               

            if (!draft && !this.checkStates()){
                return
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form5Info,
                    type:'Form5',
                    description:'Notice of Hearing of Appeal'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form5Info,
                    type:'Form5',
                    description:'Notice of Hearing of Appeal'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfHearingOfAppealId(response.data.file_id);
                        this.extractInfo();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }

    public timeFormat(value , event){        
        // if(isNaN(Number(value.slice(-1))) && value.slice(-1) != ':') return value.slice(0,-1) 
        // if(value.length!=3 && value.slice(-1) == ':') return value.slice(0,-1);
        // if(value.length==2 && event.data && value.slice(0,1)>=6 && value.slice(-1)>=6) return value.slice(0,-1);
        // if(value.length==2 && event.data && value.slice(-1)<6) return '0'+value.slice(0,1)+':'+value.slice(1,2);
        // if(value.length==2 && event.data && value.slice(0,1)>=2 && value.slice(0,1)<6 && value.slice(-1)>=6) return '00:'+value.slice(0,2);            
        // if(value.length==2 && event.data && value.slice(0,1)<2 && value.slice(-1)>=6) return value.slice(0,2)+':';
        // if(value.length==4 && value.slice(-1)>=6) return value.slice(0,-1);
        // if(value.length==3 && value.slice(0,1)!=':' && value.slice(1,2)!=':' && value.slice(-1)<6) return value.slice(0,2)+':'+value.slice(2,3);
        // if(value.length==3 && value.slice(-1)>=6 ) return value.slice(0,-1);
        // if(value.length==6 && value.slice(0,1)==0 && value.slice(4,6)<60 && (value.slice(1,2)+value.slice(3,4))<24) return value.slice(1,2)+value.slice(3,4)+':'+value.slice(4,5)+value.slice(5,6);           
        // if(value.length>5) return value.slice(0,5);
        // if(value.length==5 && (value.slice(0,2)>=24 || value.slice(3,5)>=60)) return '';
        // if(value.length==5 && ( isNaN(value.slice(0,2)) || isNaN(value.slice(3,5)) || value.slice(2,3)!=':') )return '';
        // if(value.length==4 && ( isNaN(value.slice(0,2)) || isNaN(value.slice(3,4)) || value.slice(2,3)!=':') )return '';
        return value
    }

    public dayFormat(value , event){
        return value;
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form5"}) 
    }

}
